/**
 * Store implementation heavily influenced by https://github.com/jamiebuilds/unstated/blob/master/src/unstated.js
 */
/**
 * Stores state and updates listeners of state changes
 */
export class Store {
    constructor(defaultState) {
        this.listeners = [];
        /**
         * Sets the stores state
         */
        this.setState = (stateOrUpdateFunction, callback) => {
            let nextState;
            if (typeof stateOrUpdateFunction === 'function') {
                nextState = stateOrUpdateFunction(this.state);
            }
            else {
                nextState = stateOrUpdateFunction;
            }
            if (nextState == null) {
                if (callback)
                    callback(this.state, this.state); // nothing has changed, so previous state is the current state.
                return;
            }
            this.prevState = this.state;
            this.state = Object.assign({}, this.prevState, nextState);
            if (callback) {
                callback(this.state, this.prevState);
            }
            this.listeners.forEach(listener => listener(this.state, this.prevState));
        };
        /**
         * Resets the state to the default state value.
         */
        this.reset = (callback) => {
            return this.setState(this.initialState, callback);
        };
        /**
         * Adds a listener to be updated when the state changes.
         * Returns an unsubscribe function.
         */
        this.subscribe = (fn) => {
            this.listeners.push(fn);
            return () => this.unsubscribe(fn);
        };
        /**
         * Remove a listener.
         */
        this.unsubscribe = (fn) => {
            this.listeners = this.listeners.filter(f => f !== fn);
        };
        this.state = defaultState || {};
        this.prevState = undefined;
        this.initialState = this.state;
    }
}
//# sourceMappingURL=Store.js.map